import React from 'react';
import { FaGraduationCap, FaChartLine, FaCalculator } from 'react-icons/fa';

export type ReportCategory = 'education' | 'financial' | 'accounting';

interface ReportHeaderProps {
  title: string;
  description: string;
  metadata: {
    label: string;
    value: string;
  }[];
  category?: ReportCategory;
}

const categoryStyles: Record<
  ReportCategory,
  { background: string; color: string; icon: React.ElementType }
> = {
  education: {
    background: '#f0f7ff',
    color: '#0066cc',
    icon: FaGraduationCap,
  },
  financial: {
    background: '#f0fff4',
    color: '#00994d',
    icon: FaChartLine,
  },
  accounting: {
    background: '#f8f0ff',
    color: '#6600cc',
    icon: FaCalculator,
  },
};

export const ReportHeader: React.FC<ReportHeaderProps> = ({
  title,
  description,
  metadata,
  category = 'education',
}) => {
  const style = categoryStyles[category];
  const Icon = style.icon;

  return (
    <div
      style={{
        padding: '20px',
        backgroundColor: style.background,
        borderRadius: '8px',
        direction: 'rtl',
        width: '100%',
        borderLeft: `4px solid ${style.color}`,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          marginBottom: '10px',
        }}
      >
        <Icon size={24} color={style.color} />
        <h2
          style={{
            color: style.color,
            margin: 0,
            fontSize: '1.5rem',
          }}
        >
          {title}
        </h2>
      </div>
      <p
        style={{
          color: '#666',
          marginBottom: '8px',
          lineHeight: '1.5',
        }}
      >
        {description}
      </p>
      <div
        style={{
          display: 'flex',
          gap: '20px',
          marginTop: '15px',
          color: '#555',
        }}
      >
        {metadata.map((item, index) => (
          <div key={index}>
            <strong>{item.label}:</strong> {item.value}
          </div>
        ))}
      </div>
    </div>
  );
};
